<template>
  <div class="ml-5 mr-5">
    <div class="text-right">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="dots"
        color="#007bff"
        :height="45"
        :width="75"
        :is-full-page="true"
      ></loading>
    </div>
    <!-- v-data-table  -->

    <v-row style="margin-top: 0px">
      <v-col cols="12">
        <div class="file-upload-container" v-if="!showListPage">
          <h2>File Upload</h2>

          <form @submit.prevent="handleSubmit" class="upload-form">
            <div class="form-group">
              <label for="file-upload">Select File</label>
              <div class="file-input-wrapper">
                <input
                  type="file"
                  id="file-upload"
                  @change="handleFileChange"
                  class="file-input"
                  ref="fileInput"
                />
                <div class="file-info" v-if="selectedFile">
                  <span class="file-name">{{ selectedFile.name }}</span>
                  <span class="file-size"
                    >({{ formatFileSize(selectedFile.size) }})</span
                  >
                </div>
              </div>
            </div>

            <div class="form-actions">
              <button type="button" class="cancel-button" @click="handleCancel">
                Cancel
              </button>
              <button
                type="submit"
                class="submit-button"
                :disabled="!selectedFile"
              >
                Upload
              </button>
            </div>
          </form>
        </div>

        <v-btn small color="primary" style="float: right" @click="showListPage=false" v-if="showListPage">
          Add
        </v-btn>
      </v-col>
    </v-row>
    <ListingDashboard @loaderValue = "setValue" v-if="showListPage"/>
    <AddFile @loaderValue = "setValue" v-if="!showListPage" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import ListingDashboard from "./manageDashboard/ListingDashboard.vue";
import AddFile from "./manageDashboard/AddFile.vue";

export default {
  components: { Loading, ListingDashboard, AddFile },
  name: "PanelistReport",
  data() {
    return {
      selectedFile: null,
      uploadStatus: '',
      uploadSuccess: false,
      showListPage :true,
      isLoading:false
    }
  },
  methods: {
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
      this.uploadStatus = '';
    },
    setValue(value){
      this.isLoading=value;
    },
    handleSubmit() {
      let view = this;
      if (!this.selectedFile) {
        this.uploadStatus = 'Please select a file first';
        this.uploadSuccess = false;
        return;
      }
      view.isLoading=true;
      const formData = new FormData();
      formData.append('file', this.selectedFile); 
      
      
      view.$fetch({ requiresAuth: true, operation: "view", vueScope: view })
          .post(this.$url('ADD_DASHBOARD_FILE'), formData)
          .then(result => {
            view.isLoading=false;
            this.$swal.fire({
              icon: "success",
              title: result.data.message,
            }).then((res) => {
                  if (res.isConfirmed) {
                    this.handleCancel();
                  }
                });
          });
    },
    
    handleCancel() {
      this.resetForm();
      this.uploadSuccess = false;
      this.showListPage=true;
    },
    
    resetForm() {
      this.selectedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
  }
};
</script>

<style scoped>
.file-upload-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

h2 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}

.upload-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

label {
  font-weight: bold;
  color: #555;
}

.file-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.file-info {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 0.9em;
}

.file-name {
  font-weight: bold;
  color: #333;
}

.file-size {
  color: #666;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 10px;
}

button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s, transform 0.1s;
}

button:hover {
  transform: translateY(-1px);
}

button:active {
  transform: translateY(0);
}

.cancel-button {
  background-color: #f1f1f1;
  color: #333;
}

.cancel-button:hover {
  background-color: #e5e5e5;
}

.submit-button {
  background-color: #4caf50;
  color: white;
}

.submit-button:hover {
  background-color: #3d9140;
}

.submit-button:disabled {
  background-color: #cccccc;
  color: #666;
  cursor: not-allowed;
  transform: none;
}

.status-message {
  margin-top: 20px;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
}

.success {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.error {
  background-color: #ffebee;
  color: #c62828;
}
</style>
